import React, { useState, useEffect, useContext } from "react";
import { db, auth } from "../../firebase/firebaseConfig"; // Import auth
import { doc, updateDoc, getDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth"; // Import onAuthStateChanged
import Header from "../../elements/Header";
import { EnvContext } from "../../context/EnvContext";
import Footer from "../../elements/Footer";
import ShopButton from "../../elements/ShopButton";
import { useNavigate, useParams } from "react-router-dom";
import FAQ from "../../elements/FAQ";
import { width } from "@mui/system";

const ConfirmationCode = () => {
  const navigate = useNavigate();
  const { confirmationCode } = useParams();
  const environment = useContext(EnvContext);
  const [loading, setLoading] = useState(true);
  const [confirmationResult, setConfirmationResult] = useState(null);
  const [isAnonymous, setIsAnonymous] = useState(true); // Track anonymous status

  useEffect(() => {
    const confirmUser = async () => {
      setLoading(true);
      try {
        if (!confirmationCode) {
          console.error("Confirmation code is missing.");
          setConfirmationResult({ success: false, message: "Invalid confirmation link." });
          return;
        }

        const userId = confirmationCode.substring(0, 28);
        const userCode = confirmationCode.substring(28);

        if (!userId || !userCode) {
          console.error("Invalid confirmation code format.");
          setConfirmationResult({ success: false, message: "Invalid confirmation link." });
          return;
        }

        const userDocRef = doc(db, "Users/UsersList/DataBase", userId);
        const userDocSnap = await getDoc(userDocRef);

        if (!userDocSnap.exists()) {
          console.error("User not found.");
          setConfirmationResult({ success: false, message: "Invalid confirmation link." });
          return;
        }

        const userData = userDocSnap.data();

        if (userData.user_code !== userCode) {
          console.error("Incorrect user code.");
          setConfirmationResult({ success: false, message: "Invalid confirmation link." });
          return;
        }

        await updateDoc(userDocRef, {
          isAnonymous: false,
        });

        setConfirmationResult({ success: true, title: "Email verified!", message: "Now go treat yourself to something nice. You earned it!" });
        console.log("Account confirmed successfully!");
      } catch (error) {
        console.error("Error confirming account:", error);
        setConfirmationResult({ success: false, message: "Error confirming account." });
      } finally {
        setLoading(false);
      }
    };

    confirmUser();
  }, [confirmationCode, db]);

  useEffect(() => {
    // Use onAuthStateChanged to listen for auth state changes
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // Check if the user is anonymous
        setIsAnonymous(user.isAnonymous);
      } else {
        // If no user is signed in, set isAnonymous to true
        setIsAnonymous(true);
      }
    });

    // Clean up the subscription when the component unmounts
    return () => unsubscribe();
  }, [auth]);

  return (
    <div>
      <Header search={false} />
      <div
        style={{ padding: "20px", textAlign: "center", height: 500, display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}
      >
        {loading ? (
          <p>Confirming account...</p>
        ) : confirmationResult ? (
          <>
            <div style={{ height: 50 }} />
            {!confirmationResult.success && <p style={{ color: "red" }}>{confirmationResult.message}</p>}

            {confirmationResult.success && (
              <div style={{ textAlign: "center", marginBottom: 20 }}>
                <img src="/images/code_confirmation.png" alt="Confirmation" style={{ width: 240 }} />
                <div style={{ padding: "20px 0" }}>
                  <div style={{ fontWeight: 600, fontSize: "1.3rem", paddingBottom: 10 }}>{confirmationResult?.title}</div>
                  <div>{confirmationResult?.message}</div>
                </div>
                <ShopButton
                  text="Shop Now"
                  onClick={() => navigate("/shop")}
                  buttonStyle={{ background: "black", color: "white" }}
                  containerStyles={{ width: "100%" }}
                />
              </div>
            )}
          </>
        ) : (
          <p>Invalid confirmation link.</p>
        )}
      </div>
      <FAQ />
      <Footer />
    </div>
  );
};

export default ConfirmationCode;
